export const secondsToMileSeconds = (sec: number) => {
  const seconds = sec * 1000;
  return seconds;
};
